<template>
  <div class="inteBox">
    <intNavheader activeNameCheck="nine"></intNavheader>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div class="left-btn2" @click="reload()">回到本月</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="Content1Title">我的挂号排班</div>
          <div class="custom-calendar">
            <div class="calendar-wrapper">
              <div class="calendar-header">
                <div class="calendar-current-date">
                  <div style="font-size: 20px;">{{ `${currYear}年${currMonth}月` }}</div>
                  <div class="flex-start">
                    <div class="bg1"></div>
                    <div>上午 08:00~12:00</div>
                  </div>
                  <div class="flex-start">
                    <div class="bg2"></div>
                    <div>下午 14:00~18:00</div>
                  </div>
                </div>
                <div class="calendar-month-control">
                  <el-button type="primary" size="small" @click="handleMonthChange(-1)">上一月</el-button>
                  <el-button type="primary" size="small" @click="handleMonthChange(1)">下一月</el-button>
                </div>
              </div>
              <div class="calendar-week">
                <div class="calendar-week-list">
                  <div v-for="(item, index) of weekdays" :key="index" class="calendar-week-list__item">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="calendar-date-wrapper">
                <div class="calendar-date-list">
                  <div
                    class="flex-start"
                    :class="{
                      'calendar-date-list__item': true,
                      'is-current-month': item.currMonth,
                      'is-current-day': item.currDay,
                      'is-actived': item.actived,
                      disabled: item.disabled,
                      isMe: item.status == 1,
                      isOther: item.status == 2,
                    }"
                    v-for="(item, index) of dateList"
                    :key="index"
                    @click="handleActived(index, item.date)"
                  >
                    <div class="flex-space-between" style="width: 90%; height: 100%">
                      <div style="width: 25%;height: 100%;">
                        <div class="flex-center-columns" style="height: 100%;">
                          <div style="font-size: 20px; font-weight: bold;margin-bottom: 5px;margin-left: -40%;">{{ item.day }}</div>
                          <div class="lunar" style="margin-top: 5px;margin-left: -40%;">{{ item.lunar.lunarFestival ? item.lunar.lunarFestival : item.lunar.isTerm ? item.lunar.Term : item.lunar.IDayCn }}</div>
                        </div>
                        <template v-if="showStatusLabel">
                          <div class="date-status text-r" v-if="item.disabled && item.status" :class="item.status == 2 ? 'isOtherT' : 'isMeT'">
                            {{ statusArr[2].label }}
                          </div>
                          <div style="clear: both"></div>
                        </template>
                      </div>
                      <div class="flex-center-columns" style="width: 75%; height: 100%">
                        <div class="cell-content schedule-disabled flex-center-columns" v-if="item.disabled">
                          <div class="flex-space-between-columns" style="height: 80%; width: 100%" v-if="schedules[item.date]">
                            <div style="width: 100%">
                              <div v-for="(dayData, i) in schedules[item.date]" :key="i" style="margin-bottom: 5px">
                                <div class="t1 desc-disabled flex-space-between" :class="dayData.timePeriod == 1 ? 'desc-available1' : 'desc-available2'">
                                  <div class="line1"></div>
                                  <div class="flex-space-between" style="width: calc(100% - 2px)">
                                    <div class="t2">● {{ dayData.timePeriod == 1 ? "上午" : "下午" }}</div>
                                    <div>{{ `${dayData?.currentAppointmentCount}/${dayData?.quantity}个` }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="t3 flex-space-between" style="width: 100%">
                              <div style="color: #0086cb">{{ `已约 ${schedules[item.date][0]?.currentAppointmentCount + schedules[item.date][1]?.currentAppointmentCount || 0} 个` }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="cell-content schedule-available flex-center-columns" @click="handleCellClick(item.date)" v-else>
                          <div class="flex-space-between-columns" style="height: 80%; width: 100%" v-if="schedules[item.date]">
                            <div style="width: 100%">
                              <div v-for="(dayData, i) in schedules[item.date]" :key="i" style="margin-bottom: 5px">
                                <div class="t1 desc-disabled flex-space-between" :class="dayData.timePeriod == 1 ? 'desc-available1' : 'desc-available2'">
                                  <div class="" :class="dayData.timePeriod == 1 ? 'line2' : 'line3'"></div>
                                  <div class="flex-space-between" style="width: calc(100% - 2px)">
                                    <div class="t2">● {{ dayData.timePeriod == 1 ? "上午" : "下午" }}</div>
                                    <div>{{ `${dayData?.currentAppointmentCount}/${dayData?.quantity}个` }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="t3 flex-space-between" style="width: 100%">
                              <div style="color: #0086cb">{{ `已约 ${schedules[item.date][0]?.currentAppointmentCount + schedules[item.date][1]?.currentAppointmentCount || 0} 个` }}</div>
                              <div class="flex-end">
                                <div style="color: #5c955c" @click.stop="copySchedule(item)">复制</div>
                                <div style="color: #ff4949;margin-left: 5px">修改</div>
                                <div style="color: #0086cb; margin-left: 5px" @click.stop="delSchedule(item.date)">删除</div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-center" style="width: 100%; height: 100%" v-else>
                            <img class="" style="width: 30px; height: 30px" src="@/assets/img/pb_plus.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
    <!-- 排班设置弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="tempSchedule" label-width="20px" :rules="rules">
        <h4>1、设置班次、放号数量、金额</h4>
        <div>
          <div class="flex-start" v-for="(item, index) in tempSchedule.timeArray" :key="index" style="margin-top: 10px; margin-bottom: -10px">
            <el-form-item label="" style="width: 150px">
              <el-checkbox v-model="item.isHave" @change="handelChange($event, index)">{{ item.startTime }} ~ {{ item.endTime }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-input-number v-model="item.quantity" controls-position="right" size="mini" :min="0" :disabled="!item.isHave" />
              <span class="schedule-remain" style="margin-right: 10px"> 个</span>
            </el-form-item>
            <el-form-item label="">
              <el-input-number v-model="item.price" controls-position="right" size="mini" :min="0" :precision="2" :disabled="!item.isHave" />
              <span class="schedule-remain"> 元/个</span>
            </el-form-item>
          </div>
        </div>
        <!-- <template v-if="tempSchedule.mark == 'add'">
          <h4 style="margin-top: 10px">2、班次重复设置</h4>
          <el-form-item label="">
            <el-radio-group v-model="tempSchedule.scheduleMode">
              <el-radio :label="0">不重复</el-radio>
              <el-radio :label="1">每周重复</el-radio>
            </el-radio-group>
          </el-form-item>
        </template> -->
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="rest">重置</el-button>
        <el-button type="primary" @click="saveSchedule">保存</el-button>
      </template>
    </el-dialog>
    <el-dialog title="复制排班" :visible.sync="dialogCopeToday" width="30%">
      <el-form :model="copeFormToday" ref="copeFormToday" :rules="rules">
        <el-form-item label="请选择目标日期" prop="destDateList">
          <el-date-picker v-model="copeFormToday.destDateList" type="dates" placeholder="选择一个或多个日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="margin-right: 10px" size="small" :picker-options="pickerOption" />
        </el-form-item>
        <el-tag v-for="(item,index) in copeFormToday.destDateList" :key="index" type="success" style="margin-right:10px">{{item}}</el-tag>
      </el-form>
      <template #footer>
        <el-button @click="dialogCopeToday = false">取消</el-button>
        <el-button type="primary" @click="saveCopeScheduleToday('copeFormToday')">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import intNavheader from "../../components/intNavheader";
import calendarFormatter from "../../utils/calendarFormatter.js";
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
import { TimeFormatDate } from "../../utils/extend";
export default {
  components: {
    intNavheader,
  },
  inject: ["reload"],
  props: {
    data: Object, // 已选日期
    maxDays: {
      type: Number,
      default: -1, // 最多可选n天内, -1 表示不限制
    },
    showResetButton: {
      // 显示重置按钮
      type: Boolean,
      default: true,
    },
    showConfirmButton: {
      // 显示确定按钮
      type: Boolean,
      default: true,
    },
    showStatusLabel: {
      // 显示状态文字
      type: Boolean,
      default: true,
    },
  },
  data() {
    const currentDate = new Date();
    const currYear = currentDate.getFullYear();
    const currMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      pickerOption:{
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
      schedules: [],
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      weekNumdays: [0, 1, 2, 3, 4, 5, 6],
      dateList: [], // 当前日期集合
      length: 42, // 日期框长度
      currYear: currYear, // 当前年份
      currMonth: currMonth, // 当前月份
      currDate: null, // 当天日期
      activedDate: {}, // 已选日期
      statusArr: [
        // 状态
        { label: "不可预定", value: 0 },
        { label: "可预定", value: 1 },
        { label: "已预约", value: 1 },
      ],
      disabledDateList: [
        {
          date: "2025-01-01",
          status: true,
        },
        {
          date: "2025-01-03",
          status: false,
        },
      ], // 禁用日期

      dialogVisible: false,
      dialogTitle: "",
      tempSchedule: {
        doctorId: 0,
        doctorName: "",
        doctorPhone: "",
        scheduleMode: null,
        appointmentDetailList: null,
        dateMonth: null,
        doctor: null,
        date: null,
        dataTag: {
          am: false,
          amQuantity: 0,
          amPrice: 0,
          pm: false,
          pmQuantity: 0,
          pmPrice: 0,
        },
      },
      rules: {
        malfunctionMessage: [{ required: true, message: "请输入内容", trigger: "blur" }],
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        destDate: [{ required: true, message: "请选择月份", trigger: "change" }],
        quantity: [{ required: true, message: "请设置放号数量大于0", trigger: "blur" }],
        price: [{ required: true, message: "金额必须大于0", trigger: "blur" }],
      },
      dialogCopeToday:false,
      copeFormToday:{
        doctorId: 0,
        sourceDate: null,
        destDateList: null,
      },
    };
  },
  watch: {
    data: {
      immediate: false,
      handler: function (val, oldVal) {
        if (val) {
          this.activedDate = { ...val };
        }
      },
    },
  },
  computed: {
    getDiffDate() {
      if (this.maxDays === null || +this.maxDays === -1) return false;
      const date = new Date(this.currDate);
      date.setDate(date.getDate() + this.maxDays - 1);
      date.setHours(0, 0, 0, 0);
      return +date;
    },
  },
  mounted() {
    this.reservation();
  },
  methods: {
      copySchedule(doctor){
      var _this = this
      _this.copeFormToday = {
        doctorId: _this.userInfo.id,
        sourceDate: doctor.date,
        destDateList: null,
      };
      _this.dialogCopeToday = true
    },
    saveCopeScheduleToday(){
      const _this = this;
      if (!_this.copeFormToday.destDateList) {
        _this.$message({
          type: "warning",
          message: "请选择目标日期！",
        });
        return;
      }
      _this.DoctorAppointment.CopyDoctorAppointmentScheduleToOtherDay(
        _this.copeFormToday,
        function (data) {
           _this.$message.success("排班设置已保存");
          _this.dialogCopeToday = false
          _this.getNewData()
        },
        function (err) {
          _this.dialogCopeToday = false
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    formatWeekday(date) {
      const d = new Date(date);
      return this.weekdays[d.getDay()];
    },
    formatWeekdayNum(date) {
      const d = new Date(date);
      return this.weekNumdays[d.getDay()];
    },
    formatDay(date) {
      const d = new Date(date);
      return d.getDate();
    },
    formatDateMonth(date) {
      const d = new Date(date);
      return `${d.getFullYear()}${d.getMonth() + 1}`;
    },
    formatFullDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
    },
    rest() {
      this.initTimeArray();
      this.tempSchedule.scheduleMode = 0;
    },
    initTimeArray(schedule) {
      this.tempSchedule.timeArray = [];
      for (let index = 0; index < 8; index++) {
        let isHave = false;
        let quantity = null;
        let price = null;
        let startTime = "";
        let endTime = "";
        let timePeriod = 0;
        switch (index) {
          case 0:
            startTime = "08:00";
            endTime = "09:00";
            timePeriod = 1;
            break;
          case 1:
            startTime = "09:00";
            endTime = "10:00";
            timePeriod = 1;
            break;
          case 2:
            startTime = "10:00";
            endTime = "11:00";
            timePeriod = 1;
            break;
          case 3:
            startTime = "11:00";
            endTime = "12:00";
            timePeriod = 1;
            break;
          case 4:
            startTime = "14:00";
            endTime = "15:00";
            timePeriod = 2;
            break;
          case 5:
            startTime = "15:00";
            endTime = "16:00";
            timePeriod = 2;
            break;
          case 6:
            startTime = "16:00";
            endTime = "17:00";
            timePeriod = 2;
            break;
          case 7:
            startTime = "17:00";
            endTime = "18:00";
            timePeriod = 2;
            break;
        }
        if (schedule && schedule.length > 0) {
          let res = schedule.filter((i) => i.startTime == startTime);
          if (res && res.length > 0) {
            isHave = true;
            quantity = res[0].quantity;
            price = res[0].price;
          }
        }
        this.tempSchedule.timeArray.push({
          isHave: isHave,
          timePeriod: timePeriod,
          startTime: startTime,
          endTime: endTime,
          quantity: quantity,
          price: price,
        });
      }
    },
    handleCellClick(date) {
      const _this = this;
      _this.DoctorAppointment.GetDoctorAppointmentScheduleListByDate(
        _this.userInfo.id,
        date,
        function (data) {
          // const [year, month] = _this.searchForm.datepicker.split("-");
          let currMonth=_this.currMonth<10?`0${_this.currMonth}`:_this.currMonth
          let dateMonth = `${_this.currYear}${currMonth}`*1;
          const schedule = data.data;
          _this.tempSchedule = {
            doctorId: _this.userInfo.id,
            doctorName: _this.userInfo.userName,
            doctorPhone: _this.userInfo.phone,
            scheduleMode: 0,
            appointmentDetailList: null,
            dateMonth: dateMonth,
            date: date,
            timeArray: [],
            dataTag: {
              am: false,
              amQuantity: 0,
              amPrice: 0,
              pm: false,
              pmQuantity: 0,
              pmPrice: 0,
            },
            mark: "edit",
          };
          if (schedule && schedule.length > 0) {
            _this.initTimeArray(schedule);
          } else {
            _this.initTimeArray();
            _this.tempSchedule.mark = "add";
          }
          _this.dialogTitle = `${_this.userInfo.userName} - ${_this.formatFullDate(date)} - ${_this.formatWeekday(date)}`;
          _this.dialogVisible = true;
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },

    delSchedule(date) {
      this.$confirm(`确定删除【${date}】【${this.formatWeekday(date)}】排班?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const _this = this;
          _this.DoctorAppointment.DeleteDoctorAppointmentSchedule(
            _this.userInfo.id,
            date,
            function (data) {
              _this.$message.success("排班设置已删除");
              // _this.reload();
              _this.getNewData()
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    handelChange(e, index) {
      if (!e) {
        this.tempSchedule.timeArray[index].quantity = null;
        this.tempSchedule.timeArray[index].price = null;
        return;
      }
    },
    saveSchedule() {
      var _this = this;
      let array = this.tempSchedule.timeArray.filter((i) => i.isHave == true);
      if (array.length == 0) {
        _this.$message({
          type: "warning",
          message: "请至少选择一个时间段！",
        });
        return;
      }
      for (let index = 0; index < this.tempSchedule.timeArray.length; index++) {
        const element = this.tempSchedule.timeArray[index];
        if (element.isHave) {
          if (element.quantity <= 0) {
            _this.$message({
              type: "warning",
              message: `请设置${element.startTime} ~ ${element.endTime}放号数量！`,
            });
            return;
          }
          if (element.price <= 0) {
            _this.$message({
              type: "warning",
              message: `请设置${element.startTime} ~ ${element.endTime}放号金额！`,
            });
            return;
          }
        }
      }
      let appointmentDetailList = [];
      for (let index = 0; index < this.tempSchedule.timeArray.length; index++) {
        const element = this.tempSchedule.timeArray[index];
        if (element.isHave) {
          if (this.tempSchedule.mark == "add") {
            appointmentDetailList.push({
              weekDay: this.tempSchedule.scheduleMode == 1 ? this.formatWeekdayNum(this.tempSchedule.date) : -1,
              scheduleDate: this.tempSchedule.scheduleMode == 0 ? this.tempSchedule.date : null,
              timePeriod: element.timePeriod,
              startTime: element.startTime,
              endTime: element.endTime,
              quantity: element.quantity,
              price: element.price,
            });
          } else {
            appointmentDetailList.push({
              scheduleDate: this.tempSchedule.date,
              timePeriod: element.timePeriod,
              startTime: element.startTime,
              endTime: element.endTime,
              quantity: element.quantity,
              price: element.price,
            });
          }
        }
      }
      let subData = {
        doctorId: this.tempSchedule.doctorId,
        doctorName: this.tempSchedule.doctorName,
        doctorPhone: this.tempSchedule.doctorPhone,
        dateMonth: this.tempSchedule.dateMonth,
        scheduleMode: this.tempSchedule.scheduleMode,
        appointmentDetailList: appointmentDetailList,
      };
      if (this.tempSchedule.mark == "add") {
        _this.DoctorAppointment.SubmitDoctorAppointmentSchedule(
          subData,
          function (data) {
            _this.dialogVisible = false;
            _this.$message.success("排班设置已保存");
            // _this.reload()
            _this.getNewData()
          },
          function (err) {
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          }
        );
      } else {
        _this.DoctorAppointment.UpdateDoctorAppointmentSchedule(
          subData.doctorId,
          subData.appointmentDetailList,
          function (data) {
            _this.dialogVisible = false;
            _this.$message.success("排班设置已保存");
            // _this.reload()
            _this.getNewData()
            
          },
          function (err) {
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
          }
        );
      }
    },
    GetDoctorAppointmentInfoByDate(date) {
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.DoctorAppointment.GetDoctorAppointmentInfoByDate(
          date,
          function (data) {
            resolve(data.data);
          },
          function (error) {
            console.log(error);
            resolve(false);
          }
        );
      });
    },
    async reservation() {
    
      let res = await this.GetDoctorAppointmentInfoByDate(`${this.currYear}-${this.currMonth}`);
      this.disabledDateList = [];
      this.schedules = {};
      this.schedules = res;
      if (res.length > 0) {
        res.forEach((i) => {
          let date = TimeFormatDate(i.appointmentDate * 1000);
          let map = {
            date: date,
            status: i.status,
          };
          this.disabledDateList.push(map);
        });
      }
      console.log(this.disabledDateList);
      this.initCalendar();
    },
    // 初始化日历
    initCalendar() {
      this.currDate = this.dateFormatter(new Date(), "YYYY-MM-DD");
      this.handleMonthChange();
    },
    // 月份切换
    async handleMonthChange(diff = 0) {

      console.log(this.disabledDateList);
      let date = new Date();
      if (diff !== 0) {
        date = new Date(`${this.currYear}/${this.currMonth}`);
        date.setMonth(date.getMonth() + diff);
      }
      this.currYear = date.getFullYear();
      this.currMonth = date.getMonth() + 1;
      this.initDateList(this.currYear, this.currMonth - 1);
      this.getNewData()
    },
    async getNewData(){
      let res = await this.GetDoctorAppointmentInfoByDate(`${this.currYear}-${this.currMonth<10?`0${this.currMonth}`:this.currMonth}`);
      this.disabledDateList = [];
      this.schedules = {};
      this.schedules = res;
      if (res.length > 0) {
        res.forEach((i) => {
          let date = TimeFormatDate(i.appointmentDate * 1000);
          let map = {
            date: date,
            status: i.status,
          };
          this.disabledDateList.push(map);
        });
      } 
    },
    // 根据指定年、月份生成日期数组
    initDateList(year, month) {
      const firstDate = new Date(year, month, 1); // 当前月第一天
      const firstDayWeek = firstDate.getDay(); // 当前月第一天为星期几
      const lastDate = new Date(year, month + 1, 0); // 当前月最后一天
      const lastDayWeek = lastDate.getDay(); // 当前月最后一天为星期几
      const maxDay = lastDate.getDate(); // 当前月最大天数

      /*
       * 下面分步获取日历的方式也可改为，先算出日历面板上第一个日期的节点，然后在逐步遍历 this.length 次
       */
      // 当月日期
      let dateList = this.getDateList(firstDate, maxDay, true);

      // 补充上月部分日期
      firstDate.setDate(-firstDayWeek + 1);
      dateList = [...this.getDateList(firstDate, firstDayWeek), ...dateList];

      // 补充下月部分日期
      lastDate.setDate(maxDay + 1);
      dateList = [...dateList, ...this.getDateList(lastDate, this.length - dateList.length)];
      this.dateList = dateList;
    },
    // 获取日期数组
    getDateList(date, maxDay, currMonth = false) {
      const dateList = [];
      for (let i = 0; i < maxDay; i++) {
        if (i > 0) date.setDate(date.getDate() + 1);
        const dateDay = this.dateFormatter(date, "YYYY-MM-DD");
        const activatedDay = this.activedDate[dateDay];
        let disabledDates = this.disabledDateList.filter((i) => dateDay.indexOf(i.date) > -1);
        if (disabledDates.length > 0) {
          dateList.push({
            date: dateDay,
            day: date.getDate(),
            currMonth,
            currDay: dateDay === this.currDate ? true : false,
            disabled: true,
            actived: false,
            qty: activatedDay?.qty || 0,
            lunar: this.solar2lunar(date),
            status: disabledDates[0].status,
          });
        } else {
          dateList.push({
            date: dateDay,
            day: date.getDate(),
            currMonth,
            currDay: dateDay === this.currDate ? true : false,
            disabled: this.disabledDate(date) || dateDay === this.currDate,
            actived: activatedDay?.actived || false,
            qty: activatedDay?.qty || 0,
            lunar: this.solar2lunar(date),
            status: 0,
          });
        }
      }
      return dateList;
    },
    // 日期选中、取消
    handleActived(index, val) {
      const dateList = this.dateList;
      if (!dateList[index].disabled) {
        if (dateList[index].actived) {
          // alert('确定取消？')
          this.$set(dateList[index], "actived", false);
          delete this.activedDate[val];
        } else {
          this.$set(dateList[index], "actived", true);
          this.activedDate[val] = dateList[index];
        }
      }
    },
    // 禁用日期
    disabledDate(time) {
      const date = new Date(`${this.currDate}`).setHours(0, 0, 0, 0);
      return +time < +date || (this.getDiffDate && +time > this.getDiffDate);
    },
    dateFormatter(date, formatter = "YYYY-MM-DD HH:mm:ss") {
      date = date ? new Date(date) : new Date();
      const Y = date.getFullYear() + "",
        M = date.getMonth() + 1,
        D = date.getDate(),
        H = date.getHours(),
        m = date.getMinutes(),
        s = date.getSeconds();
      return formatter
        .replace(/YYYY|yyyy/g, Y)
        .replace(/YY|yy/g, Y.substr(2, 2))
        .replace(/MM/g, (M < 10 ? "0" : "") + M)
        .replace(/DD/g, (D < 10 ? "0" : "") + D)
        .replace(/HH|hh/g, (H < 10 ? "0" : "") + H)
        .replace(/mm/g, (m < 10 ? "0" : "") + m)
        .replace(/ss/g, (s < 10 ? "0" : "") + s);
    },
    // 阳历转农历
    solar2lunar(date) {
      return calendarFormatter.solar2lunar(date.getFullYear(), date.getMonth() + 1, date.getDate());
    },
    // 重置日历
    handleResetCalendar() {
      this.activedDate = {};
      this.handleMonthChange();
    },
    // 日历点击确定
    handleConfirmCalendar() {
      this.$emit("update", this.activedDate);
      var _this = this;
      let dates = Object.keys(this.activedDate);
      let appointmentDateList = [];
      dates.forEach((t) => {
        appointmentDateList.push(new Date(t + " 00:00:00").getTime() / 1000);
      });
      if (appointmentDateList.length == 0) {
        this.$message({
          type: "error",
          message: "请选择日期！",
        });
        return;
      }
      let map = {
        expertUserId: this.reservationInfo.id,
        appointmentDateList: appointmentDateList,
      };
      _this.ExpertAppointment.SaveAppointment(
        map,
        function (data) {
          _this.reservationDialog = false;
          _this.$message({
            type: "success",
            message: "预约已提交",
          });
          // _this.reload();
           _this.getNewData()
        },
        function (error) {
          console.log(error);
          var jsonObj = JSON.parse(error.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    goBack() {
      this.addtoNew = false;
    },
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}
.titleTopLeftImg {
  width: 123px;
  height: 24px;
}
.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}
.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}
.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}
.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titleTopRight div {
  margin-left: 10px;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  /* max-height: 750px; */
  overflow: auto;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
}
.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Content1Title {
  padding: 20px 40px;
  padding-left: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 0;
  text-align: left;
}
.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}
.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}
.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}
.stepInput {
  width: 60%;
  margin-right: 10px;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.drawer-box {
  padding: 30px;
}
.el-drawer {
  background-color: #ffffff !important;
  width: 550px !important;
}
.el-drawer__body {
  overflow: auto;
}
.detail-item {
  position: relative;
  margin-bottom: 20px;
}

.detail-item .detail-tit {
  font-size: 18px;
}

.detail-item > p {
  margin: 5px 0;
}

.detail-item > p span {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.detail-item .status {
  position: absolute;
  right: 5px;
  top: 5px;
}

.detail-item .status .text-orange {
  color: orange;
}

.detail-item .status .text-blue {
  color: rgb(47, 0, 255);
}

.detail-item .status p.text-danger {
  color: red;
}

.detail-item .status p.text-succes {
  color: forestgreen;
}
</style>

<style scoped lang="scss">
.bg1 {
  width: 8px;
  height: 8px;
  background: #e58225;
  border-radius: 4px;
  margin: 0 10px;
}
.bg2 {
  width: 8px;
  height: 8px;
  background: #5c955c;
  border-radius: 4px;
  margin: 0 10px;
}
.custom-calendar {
  width: 100%;
  height: 60vh;
  min-height: calc(100vh - 160px);
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.calendar-wrapper {
  width: 100%;
  height: 100%;
  font-size: 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border: 1px solid #eee;
}
.calendar-header,
.calendar-week {
  width: 100%;
  height: 65px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
}
.calendar-week-list,
.calendar-date-list {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
}
.calendar-header > div,
.calendar-week-list > div,
.calendar-date-list > div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-week-list > div,
.calendar-date-list > div {
  height: 100%;
  width: 14.2857%;
}
.calendar-date-wrapper {
  width: 100%;
  flex-grow: 1;
}
.calendar-date-list {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.calendar-date-list .calendar-date-list__item {
  height: auto;
  color: #a0a0a0;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
}
.calendar-date-list .calendar-date-list__item .date-status {
  font-size: 11px;
  width: 100%;
  position: absolute;
  right: 2px;
  bottom: 2px;
}
.calendar-date-list .calendar-date-list__item:not(.disabled) .date-status {
  color: #f88d00;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.calendar-date-list .calendar-date-list__item:nth-child(7n + 1) {
  border-left-width: 0;
}
.calendar-date-list .calendar-date-list__item .lunar {
  font-size: 10px;
}
.calendar-date-list .calendar-date-list__item.is-current-month:not(.disabled) {
  color: #000;
}
.calendar-date-list .calendar-date-list__item.is-current-month.is-current-day {
  // color: rgba(2, 191, 111, 0.8);
  color: var(--base--Color);
}
.calendar-date-list .calendar-date-list__item.isMe {
  background: rgba(230, 247, 241, 1) !important;
  color: #333;
}
.calendar-date-list .calendar-date-list__item.isOther {
  background: rgba(255, 239, 223, 1) !important;
  color: #333;
}
.calendar-date-list .calendar-date-list__item.isMe .isMeT {
  color: #00c773;
}
.calendar-date-list .calendar-date-list__item.isOther .isOtherT {
  color: #e1750d;
}
// .calendar-date-list .calendar-date-list__item.is-current-month.is-current-day:not(.disabled):hover,
// .calendar-date-list .calendar-date-list__item.is-current-month.is-current-day.is-actived {
//   background: rgba(2, 191, 111, 0.8);
// }
.calendar-date-list .calendar-date-list__item.disabled {
  background: rgba(238, 238, 238, 0.3);
}
// .calendar-date-list .calendar-date-list__item.is-current-month:not(.disabled):hover,
// .calendar-date-list .calendar-date-list__item.is-current-month.is-actived {
//   background: rgba(2, 191, 111, 0.8);
//   color: #fff;
// }
.calendar-date-list .calendar-date-list__item:not(.disabled):hover .date-status,
.calendar-date-list .calendar-date-list__item.is-actived .date-status {
  color: #fff;
}
// .calendar-date-list .calendar-date-list__item:not(.disabled):hover,
// .calendar-date-list .calendar-date-list__item.is-actived {
//   background: rgba(2, 191, 111, 0.8);
//   color: #fff;
// }
.calendar-date-list .calendar-date-list__item.is-current-month.disabled,
.calendar-date-list .calendar-date-list__item.disabled {
  cursor: not-allowed;
}
.calendar-footer {
  width: 100%;
  height: 58px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
button.button--default {
  min-width: 60px;
  height: 38px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  cursor: pointer;
  line-height: 1;
  padding: 4px 12px;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  outline: none;
}
button.button--default + button.button--default {
  margin-left: 12px;
}
button.button--default.button--small {
  height: 34px;
}
button.button--default.button--mini {
  height: 30px;
}
button.button--default:hover {
  border-color: #3240ff;
  color: #3240ff;
}
button.button--default:active {
  background-color: #3240ff;
  border-color: #3240ff;
  color: #fff;
}
button.button--default.button--primary {
  background-color: #3240ff;
  border-color: #3240ff;
  color: #fff;
}
button.button--default.button--primary:hover {
  background-color: #5b66ff;
  border-color: #5b66ff;
}
button.button--default.button--primary:active {
  background-color: #2833cc;
  border-color: #2833cc;
}
.day-header {
  min-width: 100px;
  padding: 8px 4px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.day-header div:first-child {
  font-size: 21px;
  color: #333;
  font-weight: bold;
}

.day-header div:last-child {
  font-size: 10px;
  line-height: 1;
  /* color: #666; */
}

.day-cell {
  min-width: 170px;
  height: 110px;
  padding: 0;
  cursor: pointer;
}
.cell-content {
  width: 100%;
  height: 100%;
  // align-items: start !important;
  // padding: 8px 0 5px;
}
.t1 {
  width: 100%;
  margin: 0 auto;
  border-radius: 2px;
  font-size: 12px;
  padding: 0 4px 0 0;
}
.t2 {
  margin: 0 5px;
  font-size: 12px;
  font-weight: bold;
}
.t3 {
  // width: 86%;
  // margin: 0 auto;
  font-size: 12px;
  color: #cccccc;
}
.line1 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #cccccc;
}
.schedule-available {
  /* background-color: #f0f9eb; */
  color: #67c23a;
}

.schedule-partial {
  background-color: #fdf6ec;
  color: #e6a23c;
}

.schedule-full {
  background-color: #fef0f0;
  color: #f56c6c;
}

.schedule-disabled {
  background-color: #fcfcfc;
  color: #cccccc;
}
.schedule-disabled .desc-disabled {
  background: #f6f6f6;
  border: 1px solid #f0f0f0;
  color: #cccccc;
}
.schedule-available .desc-available2 {
  background: #f1f8f4;
  border-radius: 2px;
  border: 1px solid #e8f4ed;
  color: #5c955c;
}
.schedule-available .desc-available1 {
  background: #fff0e0;
  border-radius: 2px;
  border: 1px solid #ffedd9;
  color: #e58225;
}
.line1 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #cccccc;
}
.schedule-available .line2 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #e58225;
}
.schedule-available .line3 {
  width: 2px;
  height: 22px;
  border-radius: 2px 0 0 2px;
  background: #5c955c;
}
.loading-cell {
  text-align: center;
  padding: 16px;
  color: #999;
}

.schedule-remain {
  margin-left: 8px;
  font-size: 12px;
  color: #666;
}

.el-icon.is-loading {
  margin-right: 6px;
  animation: rotating 2s linear infinite;
}
</style>
